const link = {
  mobile: {
    home: "/",
    contact: "/contact",
    articles: "/articles",
    tools: "/tools",
    loginMenu: "/auth/account",
    foodDatabase: "/food-database",
    cookingVideo: "/cooking-videos",
    freePremium: "/free-premium",
    activeChallenge: "/event/2020-finish-strong-challenge",
    articleDetail: (id) => `/articles/detail/${id}`,
    cookingDetail: (id) => `/cooking-videos/detail/${id}`,
    static: (st) => `/page/${st}`,
    articleCategory: (category) => `/articles/categories/${category}`,
    downloadApp: "download-app",
    downloadAppRoot: "/app-download",
    successPayment: "/payment/success-payment",
    paymentStatus: "/payment/status",
    activateAccount: "/auth/activate",
    forgotPassword: "/auth/forgot-password",
    accountOverview: "/auth/account-overview",
    emailPreference: "/email-preference",
    fillName: "/auth/change-name",
    resetPassword: "/reset-password",
    otp: "/auth/otp",
    changeEmail: "/auth/change-email",
    errorPayment: "/payment/error-payment",
    playStore: "https://play.google.com/store/apps/details?id=com.myfitsociety",
    appStore: "https://apps.apple.com/us/app/myfitsociety-sports-fitness/id1468247837?ls=1",
    // Trello 467 — the payment_mitigation.blocked store cards on get-plan must
    // use these exact URLs (Figma 3ccS24jZ9QqpxcZj7dkY1E). playStore/appStore
    // above stay untouched: footer, payment-result, download-app and other
    // surfaces still share them.
    playStoreMitigation: "https://play.google.com/store/apps/details?id=com.myfitsociety&hl=en_US",
    appStoreMitigation: "https://apps.apple.com/id/app/calorie-counter-myfitsociety/id1468247837",
    mfsFacebook: "https://web.facebook.com/myfitsocietyofficial/",
    mfsFacebookId: "https://web.facebook.com/myfitsocietyindo/",
    mfsInstagram: "https://www.instagram.com/myfitsociety",
    mfsInstagramId: "https://www.instagram.com/myfitsocietyid",
    mfsTwitter: "https://twitter.com/myfitsociety",
    mfsPinterest: "https://id.pinterest.com/myfitsociety/",
    login: (packageId) => `/auth/login/${packageId}`,
    payment: (packageId, language, referralId, activePromo) => `/payment/purchases/${packageId}?mobileLang=${language}${referralId ? `&referral_id=${referralId}` : ""}${activePromo ? `&active_promo=${activePromo}` : ""}&websiteRequest=true`,
    paymentLanding: (packageId, language, landing_page, activePromo) => `/payment/purchases/${packageId}?mobileLang=${language}${landing_page ? "&landing_page=true" : ""}${activePromo ? `&active_promo=${activePromo}` : ""}&websiteRequest=true`,
    privacyPolicy: "/page/privacy-policy",
    about: "/page/about",
    contactUs: "/page/contact-us",
    termsOfUse: "/page/terms-of-use",
    refundPolicy: "/page/refund-policy",
    registrationSuccess: "/auth/registration-success",
    completeRegistrationData: "/auth/complete-registration",
    paymentExpired: "/payment/transaction-expired",
    businessDetail: "/business/business-detail",
    businessLogin: "/business/signin-business",
    businessOtp: "/business/otp",
    workoutLanding: "/workout-landing",
    signBusiness: "/business/signin-business",
    registerBusiness: "/business/register-business",
    businessListing: "/business/business-list",
    detailBusiness: "/business/business-detail",
    changeEmailBusiness: "/business/change-email",
    discoverBusiness: "/business/discover-business",
    planPricing: "/plan-pricing",
    accountOtp: "/auth/account-otp",
    packageList: (promoCode, promoPrice) => (promoCode ? `/package-list?c=${promoCode}` : promoPrice ? `/package-list?promo=${promoPrice}` : "/package-list"),
    bogoTerms: "/page/terms-and-conditions/bogo?wv=true",
  }
};

export default link;
